@let request = $request();
@let selectedRequestsIds = $selectedRequestsIds!();
@let ePTS = this.ePTS();
@let lPPhoto = this.lPPhoto();
@let appKDl = this.appKDl();
@let appKDkp = this.appKDkp();
@let requestRoute = ['/requests', request.requestNumber];

<!--  чекбокс-->
<td
  tuiTd
  class="px-0!"
  [style.border-inline-start]="
    '10px solid ' + request.statusId!.color + ' !important'
  "
>
  <div class="flex flex-col h-full justify-around px-2">
    <input
      tuiCheckbox
      type="checkbox"
      tuiCheckbox
      size="m"
      [ngModel]="selectedRequestsIds![request.id]"
      (ngModelChange)="onSelectRequest()"
    />
  </div>
</td>

<!--  глаз-->
<td tuiTd>
  <div class="flex items-center gap-2 flex-wrap">
    <a
      [href]="getEyeHref(request.requestNumber)"
      target="_blank"
      rel="noopener"
      [tuiHint]="
        $repossessionActionsEnabled()
          ? ('requests_list_item.guest_view' | translate)
          : ''
      "
      tuiHintAppearance="dark"
    >
      <tui-icon
        icon="@tui.eye"
        class="cursor-pointer z-50 text-[1rem]!"
      ></tui-icon>
    </a>
    @if ($repossessionActionsEnabled()) {
      <button
        type="button"
        class="inline-flex"
        [tuiHint]="'requests_list_item.generate_guest_link' | translate"
        tuiHintAppearance="dark"
        (click)="issueGuestLink(request.requestNumber, $event)"
      >
        <tui-icon
          icon="@tui.share"
          class="cursor-pointer z-50 text-[1rem]!"
        ></tui-icon>
      </button>
      <button
        type="button"
        class="inline-flex text-red-600"
        [tuiHint]="'requests_list_item.revoke_guest_links' | translate"
        tuiHintAppearance="dark"
        (click)="revokeGuestLinks(request.requestNumber, $event)"
      >
        <tui-icon
          icon="@tui.trash-2"
          class="cursor-pointer z-50 text-[1rem]!"
        ></tui-icon>
      </button>
    }
    @if (canCreateTemporaryAccess()) {
      <button
        type="button"
        class="inline-flex"
        [tuiHint]="'requests_list_item.create_temporary_access' | translate"
        tuiHintAppearance="dark"
        (click)="openTemporaryAccessDialog(request.id, $event)"
      >
        <tui-icon
          icon="@tui.user"
          class="cursor-pointer z-50 text-[1rem]!"
        ></tui-icon>
      </button>
    }
  </div>
</td>

@if (columnsMap) {
  @for (col of $desktopTableColumns(); track col) {
    <ng-container [ngTemplateOutlet]="columnsMap[col]"></ng-container>
  }
}

<!-- Request Number  Заявка (Номер заявки) -->
<ng-template #requestNumber>
  <td tuiTd [routerLink]="requestRoute">
    <p
      class="x-font-body-4"
      (click)="copyToClipboard(request.requestNumber, $event)"
    >
      {{ request.requestNumber }}
    </p>
  </td>
</ng-template>

<!-- Release Date Period Когда(время и дата) -->
<ng-template #releaseDatePeriod>
  <td tuiTd [routerLink]="requestRoute" nowrap>
    <p class="x-font-body-4-bold">
      {{ request.releaseTime | releaseTimeParser }}
    </p>
    <p class="x-font-body-4">
      {{
        request.releaseDate
          ? (request.releaseDate
            | date
              : ((request.releaseDate | date: 'yyyy') !== (today | date: 'yyyy')
                  ? 'd MMMM yyyy'
                  : 'd MMMM'))
          : ('requests_list_item.undefined_date' | translate)
      }}
    </p>
  </td>
</ng-template>

<!-- Release Date Когда(дата) -->
<ng-template #releaseDate>
  <td tuiTd [routerLink]="requestRoute" nowrap>
    <p class="x-font-body-4">
      {{
        request.releaseDate
          ? (request.releaseDate
            | date
              : ((request.releaseDate | date: 'yyyy') !== (today | date: 'yyyy')
                  ? 'd MMMM yyyy'
                  : 'd MMMM'))
          : ('requests_list_item.undefined_date' | translate)
      }}
    </p>
  </td>
</ng-template>

<!-- Release Date Когда(время) -->
<ng-template #releaseTime>
  <td tuiTd [routerLink]="requestRoute" nowrap>
    <p class="x-font-body-4-bold">
      {{ request.releaseTime | releaseTimeParser }}
    </p>
  </td>
</ng-template>

<!-- Contract Договор -->
<ng-template #contract>
  <td tuiTd [routerLink]="requestRoute">
    <p
      class="x-font-body-4 w-full"
      (click)="copyToClipboard(request.contract || '', $event)"
    >
      <img
        class="me-1.5 inline"
        [ngSrc]="requestIconResolver(request.counterpartyOwnerId.id)"
        alt="cp icon"
        width="16"
        height="16"
      />
      {{
        request.contract || 'requests_list_item.undefined_contract' | translate
      }}
    </p>
  </td>
</ng-template>

<!-- Lease Product Предмет Лизинга -->
<ng-template #carModelAndBrand>
  <td tuiTd [routerLink]="requestRoute">
    <div
      class="flex items-center"
      (click)="copyToClipboard(request.car || '', $event)"
    >
      <x-svg-icon
        [icon]="
          requestLeaseProductIconResolver(request.carType, request.carModel)
        "
        class="x-icon-svg car-type-icon-cp me-2"
      ></x-svg-icon>
      <p class="x-font-body-4 break-all">
        {{
          request.car || 'requests_list_item.undefined_lease_product'
            | translate
        }}
      </p>
    </div>
  </td>
</ng-template>

<!-- Госномер -->
<ng-template #carPlantNumber>
  <td tuiTd [routerLink]="requestRoute">
    <p
      class="x-font-body-4"
      (click)="copyToClipboard(request.carPlantNumber || '', $event)"
    >
      {{
        request.carPlantNumber ||
          ('requests_list_item.undefined_car_plant_number' | translate)
      }}
    </p>
  </td>
</ng-template>

<!-- VIN номер-->
<ng-template #vin>
  <td tuiTd [routerLink]="requestRoute">
    <p
      class="x-font-body-4"
      (click)="copyToClipboard(request.vin || '', $event)"
    >
      {{ request.vin || ('requests_list_item.no_vin' | translate) }}
    </p>
  </td>
</ng-template>

<!-- Номер проекта (projectNumber) -->
<ng-template #projectNumber>
  <td tuiTd [routerLink]="requestRoute">
    <p
      class="x-font-body-4"
      (click)="copyToClipboard(request.projectNumber || '', $event)"
    >
      {{
        request.projectNumber ||
          ('requests_list_item.undefined_project_number' | translate)
      }}
    </p>
  </td>
</ng-template>

<!-- Lease Recipient ЛП  -->
<ng-template #subjName>
  <td tuiTd class="x-font-body-4 min-w-[200px]" [routerLink]="requestRoute">
    <p
      (click)="copyToClipboard(request.subjName || '', $event)"
      class="wrap-anywhere"
    >
      {{
        request.subjName ||
          ('requests_list_item.undefined_lease_recipient' | translate)
      }}
    </p>
  </td>
</ng-template>

<!-- Address Место (адрес) -->
<ng-template #deliveryAddress>
  @let isDeliveryAddressDifferentFromActual =
    request.actualDeliveryAddress &&
    request.deliveryAddress &&
    request.actualDeliveryAddress !== request.deliveryAddress;

  @let deliveryAddressConfirmed =
    request.actualDeliveryAddress &&
    request.actualDeliveryAddress === request.deliveryAddress;

  <td tuiTd [routerLink]="requestRoute" class="min-w-[350px]">
    <p
      class="x-font-body-4 wrap-anywhere"
      [ngClass]="{
        'x-text-green':
          request.actualDeliveryAddress &&
          request.actualDeliveryAddress === request.deliveryAddress,
        'x-text-yellow':
          request.actualDeliveryAddress &&
          request.deliveryAddress &&
          request.actualDeliveryAddress !== request.deliveryAddress,
      }"
      [tuiHint]="
        request.actualDeliveryAddress &&
        request.deliveryAddress &&
        request.actualDeliveryAddress !== request.deliveryAddress
          ? ('requests_list_item.delivery_address_different_from_actual'
            | translate)
          : request.actualDeliveryAddress &&
              request.actualDeliveryAddress === request.deliveryAddress
            ? ('requests_list_item.delivery_address_confirmed' | translate)
            : ''
      "
      tuiHintAppearance="dark"
      (click)="copyToClipboard(request.deliveryAddress || '', $event)"
    >
      @if (deliveryAddressConfirmed) {
        <tui-icon
          icon="@tui.check"
          class="x-text-green size-6 text-base"
        ></tui-icon>
      }
      @if (isDeliveryAddressDifferentFromActual) {
        <tui-icon
          icon="@tui.circle-alert"
          class="x-text-yellow size-6 text-base"
        ></tui-icon>
      }
      {{
        request.deliveryAddress || 'requests_list_item.undefined_address'
          | translate
      }}
    </p>
  </td>
</ng-template>

<!-- Counterparty Name Заказчик  -->
<ng-template #counterparty>
  <td tuiTd [routerLink]="requestRoute">
    <p
      class="x-font-body-4"
      (click)="copyToClipboard(request.counterPartyName || '', $event)"
    >
      {{
        request.counterPartyName ||
          'requests_list_item.undefined_counterparty_name' | translate
      }}
    </p>
  </td>
</ng-template>

<!-- Products Товары услуги -->
<ng-template #requestProduct>
  <td tuiTd [routerLink]="requestRoute">
    <div class="flex flex-wrap">
      @for (requestProduct of request.products; track requestProduct.id) {
        <x-request-product-icon
          [requestProduct]="requestProduct"
          [requestDevices]="request.devices"
          [withCounter]="true"
          [iconSize]="RequestProductIconSize.Sm"
        ></x-request-product-icon>
      }
    </div>
  </td>
</ng-template>

<!-- Installer СЛС -->
<ng-template #installers>
  <td tuiTd [routerLink]="requestRoute">
    <p
      class="x-font-body-4"
      (click)="copyToClipboard(request.installerShort || '', $event)"
      [title]="
        request.installerId?.lastName
          ? request.installerId?.lastName +
            ' ' +
            request.installerId?.firstName +
            ' ' +
            request.installerId?.patronymic
          : ('requests_list_item.not_assigned' | translate)
      "
    >
      {{
        request.installerShort || 'requests_list_item.not_assigned' | translate
      }}
    </p>
  </td>
</ng-template>

<!-- Status Статус заявки -->
<ng-template #requestStatus>
  <td tuiTd [routerLink]="requestRoute">
    <span
      tuiBadge
      class="x-font-body-5-bold-important text-[#494C62FF]!"
      appearance="custom"
      [style.background]="request.statusId?.color"
      >{{ 'request_statuses.' + request.statusId?.id | translate }}</span
    >
  </td>
</ng-template>

<!-- Delivery Name Поставщик -->
<ng-template #deliveryName>
  <td tuiTd [routerLink]="requestRoute">
    <p
      class="x-font-body-4"
      (click)="copyToClipboard(request.deliveryName || '', $event)"
    >
      {{
        request.deliveryName || 'requests_list_item.undefined_delivery_name'
          | translate
      }}
    </p>
  </td>
</ng-template>

<!-- Created At Дата создания -->
<ng-template #createdAt>
  <td tuiTd [routerLink]="requestRoute">
    <p
      class="x-font-body-4"
      (click)="copyToClipboard(request.createdAt || '', $event)"
    >
      {{ request.createdAt | date: 'dd.MM.yyyy' }}
    </p>
  </td>
</ng-template>

<!-- Updated At Дата обновления -->
<ng-template #updatedAt>
  <td tuiTd [routerLink]="requestRoute">
    <p
      class="x-font-body-4"
      (click)="copyToClipboard(request.updatedAt || '', $event)"
    >
      {{ request.updatedAt ? (request.updatedAt | date: 'dd.MM.yyyy') : '-' }}
    </p>
  </td>
</ng-template>

<!-- Quality Control Status Статус ОКК -->
<ng-template #qualityControlStatus>
  <td tuiTd [routerLink]="requestRoute">
    <p class="x-font-body-4">
      {{
        request.statusId?.name === RequestStatusNameEnum.COMPLETED
          ? request.qualityControlStatus
            ? ('quality_statuses.' + request.qualityControlStatus | translate)
            : ''
          : ('requests_list_item.request_not_completed' | translate)
      }}
    </p>
  </td>
</ng-template>

<!-- Docs Документы (Е-ПТС, ФОТО-ПЛ, АПП к ДЛ, АПП к ДКП)-->
<ng-template #docs>
  <td tuiTd [routerLink]="requestRoute">
    <div class="flex gap-1 items-center justify-center">
      <div
        class="inline-block"
        [tuiHint]="
          ePTS
            ? ('requests_list_item.epts_hint' | translate)
            : ('requests_list_item.epts_not_found' | translate)
        "
        tuiHintAppearance="dark"
      >
        <x-icon-button
          iconName="x-icon::EPTS"
          [disabled]="!ePTS"
          [size]="44"
          [clickFunction]="createLink.bind(this, 'epts')"
          [backgroundPrimary]="true"
        />
      </div>

      <div
        class="inline-block"
        [tuiHint]="
          lPPhoto
            ? ('requests_list_item.lp_photo_hint' | translate)
            : ('requests_list_item.lp_photo_not_found' | translate)
        "
        tuiHintAppearance="dark"
      >
        <x-icon-button
          iconName="x-icon::photo-lp"
          [disabled]="!lPPhoto"
          [size]="44"
          [clickFunction]="createLink.bind(this, 'lPPhoto')"
          [backgroundPrimary]="true"
        />
      </div>
      <div
        class="inline-block"
        [tuiHint]="
          appKDl
            ? ('requests_list_item.obrz_app_k_dl_hint' | translate)
            : ('requests_list_item.obrz_app_k_dl_not_found' | translate)
        "
        tuiHintAppearance="dark"
      >
        <x-icon-button
          iconName="x-icon::DL"
          [disabled]="!appKDl"
          [size]="44"
          [clickFunction]="createLink.bind(this, 'appKDl')"
          [backgroundPrimary]="true"
        />
      </div>
      <div
        class="inline-block"
        [tuiHint]="
          appKDkp
            ? ('requests_list_item.obrz_app_k_dkp_hint' | translate)
            : ('requests_list_item.obrz_app_k_dkp_not_found' | translate)
        "
        tuiHintAppearance="dark"
      >
        <x-icon-button
          iconName="x-icon::DKP"
          [disabled]="!appKDkp"
          [size]="44"
          [clickFunction]="createLink.bind(this, 'appKDkp')"
          [backgroundPrimary]="true"
        />
      </div>
    </div>
  </td>
</ng-template>
